<template>
  <!-- hidden PageHeaderWrapper title demo -->
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card>
      <a-form-model ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
        <!-- 标题 -->
        <a-form-model-item label="商品标题" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop='title'>
          <a-input placeholder="请输入商品标题" v-model="form.title"> </a-input>
        </a-form-model-item>
        <!-- 运费模板 -->
        <a-form-model-item label="运费模板" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }" prop="dispatch_ids"
          :wrapperCol="{ lg: { span: 5 }, sm: { span: 5 } }">
          <a-select placeholder="请选择运费模板" v-model="form.dispatch_ids">
            <a-select-option :value="value.id" v-for="value in initData.dispatchList" :key="value.id">{{
              value.name }}</a-select-option>
          </a-select>

        </a-form-model-item>
        <!-- 会员等级 -->
        <a-form-model-item label="会员等级" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 5 }, sm: { span: 5 } }">
          <a-select placeholder="请选择会员等级" v-model="form.growth_level_id">
            <a-select-option :value="value.id" v-for="value in initData.gradeList" :key="value.id">{{
              value.name }}</a-select-option>
          </a-select>

        </a-form-model-item>
        <!-- 商品状态 -->
        <a-form-model-item label="商品状态" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" v-if="form.status">
          <a-radio-group name="radioGroup" v-model="form.status">
            <a-radio value="up"> 上架 </a-radio>
            <a-radio value="hidden"> 隐藏 </a-radio>
            <a-radio value="down"> 下架 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <!-- 排序 -->
        <a-form-model-item label="商品排序" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop='weigh'>
          <a-row>
            <a-col :md="6" :sm="24">
              <a-input v-model="form.weigh" placeholder="请输入商品排序">
              </a-input>
            </a-col>
            <a-col :md="6" :sm="24"><span style="margin-left: 50px; color: #949393">排序的大小默认按照从大到小排列</span>
            </a-col>
          </a-row>
        </a-form-model-item>
        <!-- 商品主图 -->
        <a-form-model-item label="商品主图" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop='goodsImg'>
          <a-row>
            <a-col :md="16" :sm="24" style="display: flex">
              <div>
                <a-upload name="mediaGoods" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl"
                  class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChangeGoods"
                  v-model="form.goodsImg">
                  <dy-image :src="form.goodsImg" v-if="form.goodsImg" preview></dy-image>
                  <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
                </a-upload>
              </div>
              <span style="
                  margin-left: 50px;
                  color: #949393;
                  display: flex;
                  align-items: center;
                ">
                作用于商品列表、分享头图；建议尺寸：750*750像素
              </span>
            </a-col>
          </a-row>
        </a-form-model-item>
        <!-- 轮播图 -->
        <a-form-model-item label="轮播图" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop='fileList'>
          <a-row>
            <a-col :md="16" :sm="24" style="display: flex">
              <div style="display:flex">
                <a-upload name="mediaBanner" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader"
                  :before-upload="$beforeUpload" @change="handleChangeBanner" :file-list="form.fileList"
                  style="display:flex">
                  <a-icon type="plus" v-if="form.fileList.length < 9"></a-icon>
                </a-upload>
              </div>
              <span style="
                  margin-left: 50px;
                  color: #949393;
                  display: flex;
                  align-items: center;
                ">
                作用于商品顶部轮播
              </span>
            </a-col>
          </a-row>
        </a-form-model-item>
        <!-- 分类 -->
        <a-form-model-item label="商品分类" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop="classify">
          <a-row>
            <a-col :md="6" :sm="24">
              <a-select placeholder="请输入商品分类" v-model="form.classify" mode="multiple">
                <a-select-option :value="value.id" v-for="value in initData.classifyOptions" :key="value.id">{{
                  value.name
                }}</a-select-option>
              </a-select>
            </a-col>
            <!-- <a-col :md="6" :sm="24"
              ><span style="cursor: pointer; margin-left: 50px; color: #949393"
                >新建分类</span
              >
            </a-col> -->
          </a-row>
        </a-form-model-item>
        <!-- 商品重量 -->
        <a-form-model-item label="商品重量" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }">
          <a-row>
            <a-col :md="6" :sm="24">
              <a-input placeholder="请输入商品重量" v-model="form.weight">
              </a-input>
            </a-col>

          </a-row>
        </a-form-model-item>
        <!-- 假销量 -->
        <a-form-model-item label="虚增销量" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 6 }, sm: { span: 6 } }">
          <a-input placeholder="请输入商品销量" v-model="form.fakeSales">
          </a-input>
        </a-form-model-item>
        <!-- 假浏览人数 -->
        <!-- <a-form-model-item
          label="浏览人数"
          :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 6 }, sm: { span: 6 } }"
        >
          <a-input placeholder="请输入商品浏览人数" v-model="form.fakePageView">
          </a-input>
        </a-form-model-item> -->
        <!-- 售卖价格 -->

        <a-form-model-item label="售卖价格" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop='price'>
          <a-row>
            <a-col :md="7" :sm="24">
              <a-input v-model="form.price" placeholder="请输入商品售卖价格" addon-after="元">
              </a-input>
            </a-col>
            <a-col :md="6" :sm="24"><span style="margin-left: 50px; color: #949393">商品没有优惠的价格</span>
            </a-col>
          </a-row>
        </a-form-model-item>
        <!-- 划线价格 -->
        <a-form-model-item label="划线价格" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop='linePrice'>
          <a-row>
            <a-col :md="7" :sm="24">
              <a-input v-model="form.linePrice" placeholder="请输入商品划线价格" addon-after="元">
              </a-input>
            </a-col>
            <a-col :md="6" :sm="24"><span style="margin-left: 50px; color: #949393">划线价格在商品左侧</span>
            </a-col>
          </a-row>
        </a-form-model-item>
        <!-- 商品库存 -->
        <a-form-model-item label="商品库存" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop='stock'>
          <a-row>
            <a-col :md="7" :sm="24">
              <a-input v-model="form.stock" placeholder="请输入商品库存" addon-after="个">
              </a-input>
            </a-col>
          </a-row>
        </a-form-model-item>
        <!-- 商品参数 -->
        <a-form-model-item label="商品参数" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }">
          <a-row>
            <a-col :md="7" :sm="24">
              <a-table :columns="columns" :data-source="form.params_arr" :pagination="false" bordered>
                <span slot="title" slot-scope="text, record" v-if="record">
                  <a-input v-model="record.title"></a-input>
                </span>

                <span slot="content" slot-scope="text, record" v-if="record">
                  <a-input v-model="record.content"></a-input>
                </span>

                <span slot="action" slot-scope="text, record,index">
                  <a @click="delTableData(index)">删除</a>
                </span>

              </a-table>
              <a-button type="link" @click="addTableData">添加</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>

        <!-- 图文详情 -->
        <a-form-model-item label="图文详情" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }">

          <editor name="editor" v-model="form.rich"></editor>
        </a-form-model-item>
        <a-form-model-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-row>
            <a-col>
              <a-button type="primary" style="margin-right: 20px" @click="submit">提交</a-button>
              <a-button style="margin-left: 8px" @click="goBack">取消</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import QuillEditor from "@/components/Editor/QuillEditor";
import GoodsService from "@/io/goods_list.js";
import GoodsTypeService from "@/io/goods_type.js";
import LogisticsModelService from "@/io/logistics/model.js";
import VipGradeService from '@/io/vip/grade.js'


export default {
  components: {
    QuillEditor,
  },
  name: "CreateGoods",
  data() {
    return {
      initData: {
        classifyOptions: [],
        dispatchList: [],
        gradeList: []
      },
      avatar: {
        goodsLoading: false,
        bannerLoading: false,
      },
      form: {
        rich: null,
        title: null,
        subtitle: null,
        status: null,
        weigh: null,
        weight: null,
        classify: [],
        fakeSales: null,
        fakePageView: null,
        price: null,
        linePrice: null,
        stock: null,
        goodsImg: null,
        fileList: [],
        params_arr: [],
        dispatch_ids: [],
        growth_level_id: []
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入商品标题",
          }
        ],
        dispatch_ids: [
          {
            required: true,
            message: "请选择运费模板",
          }
        ],
        weigh: [
          {
            required: true,
            message: "请输入商品排序",
          }
        ],
        goodsImg: [
          {
            required: true,
            message: '请上传商品主图'
          }
        ],
        fileList: [
          {
            required: true,
            message: '请上传轮播图'
          }
        ],
        classify: [
          {
            required: true,
            message: '请选择商品分类'
          }
        ],
        price: [
          {
            required: true,
            message: '请填写商品价格'
          }
        ],
        linePrice: [
          {
            required: true,
            message: '请填写商品划线价格'
          }
        ],
        stock: [
          {
            required: true,
            message: '请填写商品库存'
          }
        ],
      },
      previewVisible: false,
      previewImage: "",
      columns: [{
        title: '参数名称',
        dataIndex: 'title',
        slot: "title",
        scopedSlots: { customRender: 'title' },
      },
      {
        title: '参数内容',
        dataIndex: 'content',
        scopedSlots: { customRender: 'content' },
      },
      {
        title: '操作',
        scopedSlots: { customRender: 'action' },
      }
      ]
    }
  },
  mounted() {
    this.initSelectData();
    this.initGoodsDetialData();
  },
  methods: {
    // 删除参数
    delTableData(index) {
      this.form.params_arr.splice(index, 1)
    },
    // 添加参数
    addTableData() {
      this.form.params_arr.push({
        title: '',
        content: ''
      })
    },
    // 提交
    submit() {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        let bannerStr = this.getBannerStr()
        const { title, weigh, fakeSales, goodsImg, price, linePrice, stock, classify, status, rich, weight, dispatch_ids, growth_level_id } = this.form;
        const params_arr = this.form.params_arr.filter(val => {
          return val.title || val.content
        })
        if (!this.$route.params.id) {
          // 适用服务id
          const res = await GoodsService.add(
            title,
            weigh,
            fakeSales,
            goodsImg,
            bannerStr,
            classify,
            price,
            rich,
            linePrice,
            stock,
            weight,
            params_arr,
            dispatch_ids,
            growth_level_id
          );
          this.$afterFormSubmit("创建成功", () => {
            this.$router.push("/platform/goodslist");
          });
        } else {
          const res = await GoodsService.edit(
            Number(this.$route.params.id),
            title,
            weigh,
            status,
            fakeSales,
            goodsImg,
            bannerStr,
            classify,
            price,
            rich,
            linePrice,
            stock,
            weight,
            params_arr,
            dispatch_ids,
            growth_level_id
          );
          this.$afterFormSubmit("修改成功", () => {
            this.$router.push("/platform/goodslist");
          });
        }
      });
    },
    // 初始化选择框数据
    async initSelectData() {
      GoodsTypeService.list().then(res => this.initData.classifyOptions = res.data.rows);
      LogisticsModelService.list().then(res => this.initData.dispatchList = res.data.rows)
      VipGradeService.list().then(res => this.initData.gradeList = res)

    },
    // 编辑页面获取商品数据
    async initGoodsDetialData() {
      if (this.$route.params.id) {
        const res = await GoodsService.info(this.$route.params.id)
        // title, weigh,fakeSales, goodsImg, price, linePrice, stock, classify
        const { detail } = res.data
        this.form.title = detail.title
        this.form.weigh = detail.weigh
        this.form.fakeSales = detail.show_sales
        this.form.goodsImg = detail.image
        this.form.price = detail.price
        this.form.stock = detail.stock
        this.form.status = detail.status
        this.form.linePrice = detail.original_price
        this.form.rich = detail.content
        this.form.weight = detail.weight
        this.form.params_arr = detail.params ? JSON.parse(detail.params) : []
        this.form.classify = detail.category_ids_arr.map(val => {
          return Number(val)
        })
        this.form.dispatch_ids = Number(detail.dispatch_ids)
        this.form.growth_level_id = detail.growth_level_id
        let i = 0
        this.form.fileList = detail.images.map(val => {
          return {
            uid: i++,
            name: `images${i++}`,
            status: 'done',
            url: val
          }
        });
      }
    },
    // 上传商品图片
    handleChangeGoods(info) {
      let status = info.file.status;
      if (status) {
        if (status === "done") {
          this.avatar.goodsLoading = false;
          this.form.goodsImg = info.file.response.mediaGoods;
        } else if (status === 'error') {
          this.$message.error(info.file.response.message)
          this.avatar.goodsLoading = false;
        } else {
          this.avatar.goodsLoading = true;
        }
      }
    },
    // 上传轮播图
    handleChangeBanner(info) {
      let status = info.file.status;
      if (status) {
        if (status === 'error') {
          this.$message.error(info.file.response.message)
        } else {
          this.form.fileList = info.fileList.map(val => {
            return {
              uid: val.uid,
              name: val.name,
              status: val.status,
              url: val.url || (val.response ? val.response.mediaBanner : null)
            }
          });
        }


      }
    },
    // 获取字符串bannerlist
    getBannerStr() {
      let str = ''
      this.form.fileList.map((val) => {
        if (str != '') {
          str += `,${val.url}`
        } else {
          str = val.url
        }
      })
      return str
    },
    goBack() {
      this.$router.push('/platform/goodslist')
    },
  },
};
</script>
<style lang="less" scoped>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.row-box {
  display: flex;
}

.tip {
  display: flex;
  align-items: center;
  margin-left: 50px;
  // margin-bottom: 20px;
  color: #949393;
}
</style>
